import React from "react";
import { Link, StaticQuery, useStaticQuery } from "gatsby";
import styled from "styled-components";
import CallButtonV2 from "./CallButtonV2";
import LinkButtonV2 from "./LinkButtonV2";
import Img from "gatsby-image";


const MestoInner = styled.div`
  background: #F4F3F0;
  border-radius: 20px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 60px 0;
  width: calc(100% - 50px);

  @media (max-width: 600px) {
    width: calc(100% - 20px);
    padding: 40px 0;
  }


  ${props => props.white && `
    margin: 70px auto;
    padding: 0;
    max-width: 1150px;
    width: calc(100% - 100px);
    background: none;

    @media (max-width: 899px) {
      width: calc(100% - 50px);
    }
  
    @media (max-width: 600px) {
      padding: 0;
      margin: 50px auto;
    }
  `}
  
  .wrap {
    max-width: 1150px;
    width: calc(100% - 100px);
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 950px) {
      display: block;
      max-width: 700px;
      width: calc(100% - 60px);
    }

    @media (max-width: 899px) {
      max-width: 700px;
    }

    @media (max-width: 430px) {
      width: calc(100% - 40px);
    }

    ${props => props.white && `
      width: calc(100%);

      @media (max-width: 950px) {
        width: calc(100%);
      }
      @media (max-width: 430px) {
        width: calc(100%);
      }
    `}


    .left {
      width: calc(100% - 400px - 70px);

      @media (max-width: 1100px) {
        width: calc(100% - 300px - 50px);
      }

      @media (max-width: 950px) {
        margin-bottom: 40px;
        width: 100%;
      }

      h2 {
        font-family: NewKansas;
        font-size: 36px;
        color: #2c4668;
        line-height: 50px;
        margin-bottom: 35px;

        @media (max-width: 899px) {
          font-size: 32px;
          line-height: 40px;
        }

        @media (max-width: 430px) {
          font-size: 28px;
          line-height: 35px;
        }
      }

      p {
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #394B5C;
        line-height: 25px;

        @media (max-width: 430px) {
          font-size: 15px;
          line-height: 22px;
        }

        a {
          color: #394B5C;
        }
      }

      .buttons {
        display: flex;
        margin-top: 35px;

        @media (max-width: 1220px) {
          display: block;
        }

        @media (max-width: 950px) {
          display: flex;
        }
        
        @media (max-width: 725px) {
          display: block;
        }
        
        div {
          margin-right: 20px;

          @media (max-width: 1220px) {
            margin-right: 0;
            margin-top: 15px;
          }

          @media (max-width: 950px) {
            margin-right: 20px;
            margin-top: 0;
          }

          @media (max-width: 725px) {
            margin-right: 0;
            margin-top: 15px;
          }
        }
      }
    }

    .right {
      width: 400px;

      @media (max-width: 1100px) {
        width: 300px;
      }

      @media (max-width: 950px) {
        width: 100%;
      }

      .obrazek {
        @media (max-width: 1100px) {
          height: 300px !important;
          width: 300px !important;
        }

        @media (max-width: 360px) {
          height: 250px !important;
          width: 250px !important;
        }
      }

      p {
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #000;
        line-height: 25px;
        margin-top: 20px;

        @media (max-width: 430px) {
          font-size: 15px;
          line-height: 22px;
        }

        a {
          color: #000;
        }
      }

      iframe {
        width: 100%;
        height: 400px;

        @media (max-width: 1100px) {
          height: 300px;
        }
      }
    }
  }
`;


const Mesto = ({mapLocation, mestoText, mestoH2, baby, white}) => {
  let data = useStaticQuery(graphql`
    query {
      pamatecni: file(relativePath: { eq: "pamatecni_predmety.png" }) {
        childImageSharp {
          fixed(width: 400) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }

      extraSluzby: file(relativePath: { eq: "extraSluzby.png" }) {
        childImageSharp {
          fixed(width: 400) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `);

  return (
    <MestoInner white={white}>
      <div className="wrap">
        <div className="left">
          <h2>{mestoH2}</h2>
          <p>{mestoText}</p>
          <div className="buttons">
            <LinkButtonV2 to={baby ? "https://docs.google.com/forms/d/e/1FAIpQLScKgc40Rm7Y0sTrQ0zQjsYM4BI3wShwUAP_5ma7_KvEfh03WQ/viewform?usp=sf_link" : "/nabidka/dotaznik/"} arrow text="Získejte nabídku zdarma" />
            <CallButtonV2 />
          </div>
        </div>
        <div className="right">
          {/* {mapLocation} */}

          {baby ? <>
            <Img className="obrazek" alt={"Pohřebí služba " + mapLocation} fixed={data.pamatecni.childImageSharp.fixed} />
            <p>A desítky dalších skleněných produktů...</p>
          </>: <>
            {white ?
              <>
                <Img className="obrazek" alt={"Smuteční služby"} fixed={data.extraSluzby.childImageSharp.fixed} />
                <p>A desítky dalších produktů a služeb...</p>
              </>
            :
              <iframe
                frameBorder="0"
                title={mapLocation}
                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDR-wPIwbrQ2srKQ5FYSRXXCxdbPgAFhS4&q=${mapLocation}`}>
              </iframe>
            }

            
          </>}
        </div>
      </div>
    </MestoInner>
  );
}

export default Mesto;


